export interface GoogleCastState {
  isLoading: boolean
  isReady: boolean
  isProxyReady: boolean
  gcInitialized: boolean
  gcToSAccepted: boolean
  gcUsageReportSet: boolean
  errorTitle?: string
  errorKey?: string
  pairingStatus: boolean
  code?: string
  qrcodeUrl?: string
  registerUrl?: string
  wifiSSID?: string
  wifiPassword?: string
}

export enum GoogleCastQRCodeMode {
  CODE = 'CODE',
  WIFI = 'WIFI',
}

export interface GoogleCastProxyServerState {
  hasError: boolean
  pairingStatus: boolean
  code?: string
  qrcodeUrl?: string
  registerUrl?: string
  wifiSSID?: string
  errorKey?: string
}
